import ActionTypes from '@ziynx/action-types';

const initialState = {};

export default function reduceIntake(state = initialState, action) {
  if (!action.type) {
    return state;
  }

  const intakeSubmission = state[action?.id] ?? {};

  switch (action?.type) {
  case ActionTypes.intake.postIntakeSubmission.START:
    return {
      ...state,
      ...{
        ...intakeSubmission,
        posting: true,
        success: false,
        error: null,
      },
    };
  case ActionTypes.intake.postIntakeSubmission.SUCCESS:
    return {
      posting: false,
      success: true,
      error: null,
    };
  case ActionTypes.intake.postIntakeSubmission.ERROR:
    return {
      ...state,
      ...{
        ...intakeSubmission,
        success: false,
        error: action?.error,
      },
    };

  case ActionTypes.intake.clearIntake:
    return initialState;

  default:
    return state;
  }
}
